export default __webpack_public_path__ + "static/media/solution_ima.19e2c126.png";